import React, { useState } from "react";
import {
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Xicon from "../../../../images/x-lg.svg";

function TableOfContents(props) {
  const { passed } = props.info;
  const [seriesToggle, setSeriesToggle] = useState(false);
  let inventory_details = "";

  // Replace regex-based stripping with DOM parsing to avoid ReDoS/backtracking risk.
  function stripHtml(input) {
    if (typeof input !== "string" || input.length === 0) return input;
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.body.textContent || "";
  }

  let output = [];
  let output1 = [];
  let output2 = [];

  passed.forEach((item, id) => {
    //each section included in the finding aid, creating anchor link
    output1.push(
      <dt key={id}>
        <a
          onClick={() => {
            props.setToggled(false);
          }}
          href={`#${item.anchor}`}
        >
          {item.name}
        </a>
      </dt>
    );
    // if we have an inventory, we need to include a view series button with details.
    if (item.name === "Inventory") {
      inventory_details = [];
      item.data.forEach((c0) => {
        if (Object.keys(c0)[0] !== "inventory_header") {
          inventory_details.push(c0);
        }
      });

      inventory_details.forEach((subitem, index) => {
        let series = index + 1;
        if (Object.keys(subitem)[0] === "c01") {
          let subcoltitle = { ...subitem.c01.container_summary };
          let subcolstring = "";
          if (subcoltitle["Title:"] !== undefined) {
            subcolstring = String(subcoltitle["Title:"].join(""));
            if (subcolstring.includes("</")) {
              subcolstring = stripHtml(subcolstring);
            }
          }

          output2.push(
            <li key={index}>
              <a
                href={"##series" + series}
                onClick={() => {
                  setSeriesToggle(!seriesToggle);
                }}
              >
                {subcolstring.length > 0 ? subcolstring : `Item $ {index + 1}`}
              </a>
            </li>
          );
        }
      });
    }
  });

  output.push(output1);

  return (
    <div>
      <div className="card">
        <AccordionItemHeading className="card-header">
          <AccordionItemButton>
            <div className="card-title lead">Table of Contents</div>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className="card-body">
          {output.length > 0 && (
            <div>
              <dl>{output}</dl>
              {/* validate there is an inventory for view series details */}
              {output2.length > 0 && (
                <button
                  className="btn btn-primary dark-bg"
                  onClick={() => setSeriesToggle(!seriesToggle)}
                >
                  View Inventory
                </button>
              )}
            </div>
          )}
        </AccordionItemPanel>
      </div>
      {output2.length > 0 && (
        <div
          id="subcol-popup"
          className={`p-5 ${seriesToggle ? "" : "hidden"}`}
        >
          <a className="close">
            <img
              src={Xicon}
              alt="X to close modal"
              onClick={() => setSeriesToggle(!seriesToggle)}
            />
          </a>
          <ul>{output2}</ul>
        </div>
      )}
    </div>
  );
}

export default TableOfContents;
